import pick from 'lodash/pick';
import { paginationFields } from '@/models/pagination.model';
import { showApiErrors } from '@/utils';
import { createSlice } from '@reduxjs/toolkit';
import { getConversations } from './actionCreators';
import { ConversationsState, SLICE_NAME, initialState } from './models';

export const conversationsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getConversations.pending, (state: ConversationsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getConversations.fulfilled, (state: ConversationsState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.conversations = payload.conversations;
        state.pagination = pick(payload, paginationFields);
      })
      .addCase(getConversations.rejected, (state: ConversationsState, action) => {
        const { error } = action;

        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      });
  },
});
